import React from "react";
import colorSharp from "../assets/img/color-sharp.png"

export const About = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <section className="about" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="about-bx wow zoomIn">
                            <h1>Coding Profiles</h1>
                            <p>700+ DSA problems &nbsp; | &nbsp; Interview Preperation &nbsp; | &nbsp; 1,250+ contributions &nbsp; | &nbsp; Open Source </p>
                            <hr className="divider" />
                            <div className="coding-links">
                                <div className="coding-img">
                                    <a href="https://github.com/dakshgupta2002"><img className="skillLogo" src="/coding/gh.png" alt="GITHUB" /></a>
                                    <div className='skillLabel'>Github</div>
                                </div>

                                <div className="coding-img">
                                    <a href="https://leetcode.com/dakshgupta2002/"><img style={{padding: '7.5px'}} className="skillLogo" src="/coding/lc.png" alt="LEETCODE" /></a>
                                    <div className='skillLabel'>Leetcode</div>

                                </div>

                                <div className="coding-img">
                                    <a href="https://codeforces.com/profile/daksh_g123"><img className="skillLogo" src="/coding/cf.png" alt="CODEFORCES" /></a>
                                    <div className='skillLabel'>Codeforces</div>
                                </div>

                                <div className="coding-img">
                                    <a href="https://www.codechef.com/users/daksh_g123"><img className="skillLogo" style={{ filter: 'invert(100%)', padding: '5px' }} src="/coding/cc.png" alt="CODECHEF" /></a>
                                    <div className='skillLabel'>Codechef</div>
                                </div>

                                <div className="coding-img">
                                    <a href="https://www.interviewbit.com/profile/daksh-gupta_884"><img className="skillLogo" src="/coding/ib.png" alt="InterviewBit" /></a>
                                    <div className='skillLabel'>InterviewBit</div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
            </div>
            <img className="background-image-left" src={colorSharp} alt="Bg" />
        </section>
    )
}
